import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Elements } from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm'

class Subscription extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }


  render(){
    const { email } = this.props.user.currentUser;

    // family:'MessinaSansWeb';
    // src: url('../fonts/MessinaSansWeb-Regular.eot'); /* IE9 Compat Modes */
    // src: url('../fonts/MessinaSansWeb-Regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    //      url('../fonts/MessinaSansWeb-Regular.woff2') format('woff2'), /* Super Modern Browsers */
    //      url('../fonts/MessinaSansWeb-Regular.woff') format('woff'); /* Pretty Modern Browsers */
    // font-weight: 400;
    // font-style: normal;
    // font-stretch: normal;
    // unicode-range: U+000D-FB04;

    const fonts = [{
        // family: 'MessinaSansWeb',
        // src: `local("MessinaSansWeb"), url("%PUBLIC_URL%/fonts/MessinaSansWeb-Regular.eot")`,
        // unicodeRange: 'U+000D-FB04',
    }]

    return (
      <div className="mw6 br2 bg-white center pa3">
        <h1>Subscription</h1>
        <Elements fonts={fonts}>
          <CheckoutForm email={email} />
        </Elements>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.user
  }),
  {}
)(Subscription)



// WEBPACK FOOTER //
// ./src/components/Subscription.js